import React, { useState, useEffect } from "react";
import { Container, Grid, Box, Button } from "@mui/material";
import List from "./inc/List";
import AddForm from "./inc/AddForm";

const CcpAdminSchools = () => {
  const [listRefresh, setListRefresh] = useState(false);

  const handleSuccess = () => {
    setListRefresh(!listRefresh);
  };

  return (
    <Container maxWidth={false} sx={{ marginTop: "100px", width: "100%" }}>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} container justifyContent="center" mb={2}>
            <AddForm onSuccess={handleSuccess} />
          </Grid>
          <Grid item xs={12}>
            <List listRefresh={listRefresh} />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CcpAdminSchools;
